import { render } from "./ExpensesReport.vue?vue&type=template&id=4b891799"
import script from "./ExpensesReport.vue?vue&type=script&lang=js"
export * from "./ExpensesReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__